import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	currentStaff: null,
	error: null,
	loading: false,
};

const staffSlice = createSlice({
	name: 'staff',
	initialState,
	reducers: {
		signInStart: (state) => {
			state.loading = true;
		},
		signInSuccess: (state, action) => {
			state.currentStaff = action.payload;
			state.loading = false;
			state.error = null;
		},
		signInFailure: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		},
		updateStaffStart: (state) => {
			state.loading = true;
		},
		updateStaffSuccess: (state, action) => {
			state.currentStaff = action.payload;
			state.loading = false;
			state.error = null;
		},
		updateStaffFailure: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		},
		deleteStaffStart: (state) => {
			state.loading = true;
		},
		deleteStaffSuccess: (state) => {
			state.currentStaff = null;
			state.loading = false;
			state.error = null;
		},
		deleteStaffFailure: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		},
		signOutStaffStart: (state) => {
			state.loading = true;
		},
		signOutStaffSuccess: (state) => {
			state.currentStaff = null;
			state.loading = false;
			state.error = null;
		},
		signOutStaffFailure: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		}
		}
});

export const {
  signInStart,
	signInSuccess,
  signInFailure,
  updateStaffStart,
  updateStaffSuccess,
  updateStaffFailure,
  deleteStaffStart,
  deleteStaffSuccess,
  deleteStaffFailure,
  signOutStaffStart,
  signOutStaffSuccess,
  signOutStaffFailure } = staffSlice.actions;
export default staffSlice.reducer;
